module.exports = __webpack_public_path__ + "static/media/horse walking.98550865.gif";